import { Avatar, Chip } from '@all-manager/design-system-v2';
import { DocumentType } from "../../../../types";
import useGetDriveConfig from "../../../google-drive/api/useGetDriveConfig";
import { getDocumentIcon } from "../../utils/getDocumentIcon";
import { getDriveThumbnailUrl } from "../../utils/getDriveThumbnailUrl";

// Fetched at twice the rendered size for sharp display on dense screens.
const THUMBNAIL_FETCH_SIZE = 48;
const THUMBNAIL_SIZE = 24;

type Props = {
  name: string;
  url: string;
  type?: DocumentType | null;
  /** Kept for compatibility: both modes render the same compact chip. */
  displayMode?: 'list' | 'mosaic';
  onDelete?: () => void;
};

const DocumentItem = (props: Props) => {
  const { data: driveConfig } = useGetDriveConfig();
  const thumbnailUrl = driveConfig && props.type?.toLowerCase() === 'photos'
    ? getDriveThumbnailUrl(props.url, THUMBNAIL_FETCH_SIZE)
    : null;
  const label = props.type ? `${props.type} · ${props.name}` : props.name;

  return (
    <Chip
      label={label}
      variant="outlined"
      href={props.url}
      target="_blank"
      rel="noopener noreferrer"
      avatar={thumbnailUrl ? (
        <Avatar size="small">
          {/* Plain img: Drive thumbnails need no-referrer, which Avatar's own image cannot set. */}
          <img src={thumbnailUrl} alt="" height={THUMBNAIL_SIZE} loading="lazy" referrerPolicy="no-referrer" />
        </Avatar>
      ) : undefined}
      icon={thumbnailUrl ? undefined : getDocumentIcon(props.type ?? '')}
      onDelete={props.onDelete}
    />
  );
};

export default DocumentItem;
